import React, { FC, ReactElement } from "react";
import clsx from "clsx";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";

// Constants
import { FOOTER_FFNII} from "../../utils/constants";
import { GetString } from "../StringResourceManager";

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    copyrightText: {
      fontSize: '0.8rem',
      lineHeight: '0.9rem',
      color: '#fff',
      alignSelf: 'center',
    },
    copyrightBox: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column-reverse',
      marginBottom: theme.spacing(2),
    },
  })
);
interface Props {
  open: boolean;
}

const Footer: React.FC<{}> = () => {
  const classes = useStyles();
  return (
    <Box className={classes.copyrightBox}>
      <Typography variant="subtitle2" gutterBottom className={clsx(classes.copyrightText)}>
        {GetString('FOOTER_VERSION')}
      </Typography>
      <Typography variant="subtitle2" gutterBottom className={clsx(classes.copyrightText)}>
        {FOOTER_FFNII}
      </Typography>
      <Typography variant="subtitle2" gutterBottom className={clsx(classes.copyrightText)}>
        {GetString('FOOTER_COPYRIGHT')}
      </Typography>
    </Box>
  );
};

export default Footer;
